/**
 * 标签列表 Model
 * 用于存储和管理标签列表，供漫画选择标签时使用
 *
 * 状态管理说明：
 * - tags: 标签列表
 * - loading: 加载状态
 * - fetchTags: 获取标签列表的方法
 *
 * 使用方式：
 * const { tags, loading, fetchTags } = useModel('tags');
 */
import { useCallback, useState } from 'react';
import { TagService } from '@/facades/contentCatalog';
import type { TagDetail } from '@/client/types.gen';

export default function useTags() {
  // 标签列表
  const [tags, setTags] = useState<TagDetail[]>([]);
  // 加载状态
  const [loading, setLoading] = useState<boolean>(false);

  // 获取标签列表
  const fetchTags = useCallback(async () => {
    setLoading(true);
    try {
      const result = await TagService.listTags({
        limit: '1000', // 获取所有标签
        status: 'active', // 只获取启用的标签
      });
      setTags(result.data || []);
    } catch (error) {
      console.error('获取标签列表失败', error);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    tags,
    loading,
    fetchTags,
  };
}
